import { ref, type Ref } from 'vue'
import { until } from '@vueuse/core'

export interface UseReadyReturn {
  isReady: Ref<boolean>
  whenReady: Promise<boolean>
  setReady: (value?: boolean) => void
}

const isReady = ref<boolean>(false)
const whenReady = until(isReady).toBe(true)

export const useReady = (): UseReadyReturn => ({
  isReady,
  whenReady,
  setReady: (value = true): void => {
    isReady.value = value
  },
})
